import React, { useRef } from "react";
import { Card, Button, Row, Col } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router";
import NoteForm, { NoteFormHandle } from "../NoteForm/NoteForm";
import { Note } from "../types/Note";
import useStyles from "../styles/useStyles";

interface Props {
  projectId: string;
  permission: string;
  projectStatus: string;
}

const Edit: React.FC<Props> = ({ projectId, permission, projectStatus }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const note: Note = location.state?.note;
  const submitRef = useRef<NoteFormHandle>(null);
  const styles = useStyles();

  return (
    <div className={styles.page}>
      <Card className={styles.card}>
        <Card.Header className={styles.cardHeader}>
          <Row className={styles.headerRow}>
            <Col sm={1}>
              <Button
                className="btnSeawhite"
                onClick={() =>
                  navigate(`/projects/${projectId}/notes`, { state: null })
                }
              >
                Cancel
              </Button>
            </Col>
            <Col className={styles.title} sm={9}>
              Edit Note
            </Col>
            {permission !== "view" && projectStatus === "building" && (
              <Col>
                <Button
                  className="squareGreenButton floatRight"
                  onClick={() => submitRef.current?.saveNote()}
                >
                  Save
                </Button>
              </Col>
            )}
          </Row>
        </Card.Header>
        <hr className={styles.hr} />
        <Card.Body>
          <NoteForm ref={submitRef} projectId={projectId} note={note} />
        </Card.Body>
      </Card>
    </div>
  );
};

export default Edit;
